import { IUtilsState } from "./types";
import { BrowserStorage, Instance, Languages } from "@const/consts";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IUtilsState = {
  instance:
    (window.localStorage.getItem(BrowserStorage.INSTANCE) as Instance) ??
    Instance.GLOBAL,
  isError403: false,
  isError404: false,
  isPrevError: false,
  errorMessage: null,
  isHeaderVisible: true,
  isMenuVisible: true,
  language:
    window.localStorage.getItem(BrowserStorage.LANGUAGE) ?? Languages.EN,
  searchContext: []
};

export const utilsSlice = createSlice({
  initialState,
  name: "utils",
  reducers: {
    resetError403: (state) => {
      state.isError403 = false
    },
    setError403: (state, action: PayloadAction<string>) => {
      state.isError403 = true,
      state.errorMessage = action.payload
    },
    resetError404: (state) => {
      state.isError404 = false;
    },
    setError404: (state) => {
      state.isError404 = true;
    },
    resetPrevError: (state) => {
      state.isPrevError = false;
    },
    setPrevError: (state, action: PayloadAction<boolean>) => {
      state.isPrevError = action.payload;
    },
    setHeaderVisible: (state, action: PayloadAction<boolean>) => {
      state.isHeaderVisible = action.payload;
    },
    setInstance: (state, action) => {
      state.instance = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setMenuVisible: (state, action: PayloadAction<boolean>) => {
      state.isMenuVisible = action.payload
    },
    setSearchContext: (state, action: PayloadAction<string[]>) => {
      state.searchContext = action.payload
    }
  }
})

const { actions, reducer } = utilsSlice;

export const {
  resetError403,
  setError403,
  resetError404,
  setError404,
  resetPrevError,
  setPrevError,
  setHeaderVisible,
  setInstance,
  setLanguage,
  setMenuVisible,
  setSearchContext
} = actions;

export default reducer;
